import { render, staticRenderFns } from "./MailCompose.vue?vue&type=template&id=39328aab&scoped=true"
import script from "./MailCompose.vue?vue&type=script&lang=js"
export * from "./MailCompose.vue?vue&type=script&lang=js"
import style0 from "./MailCompose.vue?vue&type=style&index=0&id=39328aab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39328aab",
  null
  
)

export default component.exports